module.exports = "<div class=\"modal-header\">\n    <h4>Deputy Import Modal</h4>\n    <button type=\"button\" tabindex=\"-1\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss('close')\"><span\n            aria-hidden=\"true\">&times;</span></button>\n</div>\n<div class=\"p-md\">\n    <form ng-submit=\"vm.change($close)\">\n        <input type=\"file\" id=\"csv-file\" name=\"files\" custom-on-change=\"vm.uploadFile\" />\n        <hr>\n        <button class=\"btn btn-block btn-lg btn-success\">\n            <span>Import Timesheets</span>\n        </button>\n    </form>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/modals/deputy-import/view.html
// module id = 100
// module chunks = 0